<section class="measures-wrapper">
  <div class="headline-wrapper">
    <span aria-hidden="true">1.</span>
    <h2 [innerHTML]="'moderat.sanierung.massnahmen.section.measures' | translate"></h2>
  </div>

  <fieldset>
    <div class="grid-x grid-margin-x insulation-header">
      <div class="cell small-6 medium-6">
        <legend [innerHTML]="'moderat.sanierung.massnahmen.daemmung.headline' | translate"></legend>
      </div>
      <div class="cell small-5 text-right">
        <span class="unit" [innerHTML]="'moderat.sanierung.unit.kwh.saving' | translate"></span>
      </div>
      <div class="cell small-1">
        <button type="button" class="help-button" (click)="toggleUnitHelp()" [attr.aria-expanded]="showUnitHelp" aria-controls="daemmung-help" [attr.aria-label]="'arialabel.toggle.help' | translate"><i class="icon-help-circle"></i></button>
      </div>
      @if (showUnitHelp === true) {
        <div class="cell small-12">
          <div class="callout">
            <button type="button" class="close" (click)="closeUnitHelp()" [attr.aria-label]="'arialabel.close' | translate"><i class="icon-x"></i></button>
            <div id="daemmung-help" [innerHTML]="'moderat.sanierung.massnahmen.daemmung.hilfe' | translate"></div>
          </div>
        </div>
      }
    </div>

    @if(!measureData) {
      <div class="loading"></div>
    }
    @else {
      @for (measure of measures.insulation; track measure) {
        @if(measureData[measure]) {
          <app-moderat-sanierung-measure
            (onToggleText)="onToggleText()"
            [measure]="measure"
            [inputType]="measure === 'passivhaus'? 'switch' : 'checkbox'"
            [maxSaving]="maxSaving"
            [form]="form"
            [formField]="measure"
            [saving]="measureData[measure].saving"
            [internalPortal]="internalPortal"
            [recommend]="measureData[measure].recommend"
            [recommendReason]="measureData[measure].recommendReason"
            [measureName]="getMeasureName(measure)"
            [windowPercentage]="getWindowPercentage(measure)"
          ></app-moderat-sanierung-measure>
        }
      }
    }
  </fieldset>

<fieldset class="margin">
  <div class="grid-x">
    <div class="cell small-6 medium-4">
      <legend [innerHTML]="'moderat.sanierung.massnahmen.heizung.headline' | translate"></legend>
    </div>
    <div class="cell small-6 medium-7 text-right">
      <span class="unit" [innerHTML]="'moderat.sanierung.unit.kwh.saving' | translate"></span>
    </div>
  </div>

  @if(!measureData) {
    <div class="loading"></div>
  }
  @else {
  @for(measure of measures.heating; track measure) {
    @if(measureData[measure]) {
      <app-moderat-sanierung-measure
        (onToggleText)="onToggleText()"
        [value]="measure"
        [maxSaving]="maxSaving"
        inputType="radio"
        [measure]="measure"
        [internalPortal]="internalPortal"
        [form]="form"
        formField="heating"
        [textPostfix]="getTextPostfix(measure)"
        [saving]="measureData[measure].saving"
        [recommend]="measureData[measure].recommend"
        [recommendReason]="measureData[measure].recommendReason"
        [isMeasureDistrictDisabled]="isMeasureDistrictDisabled(measure)"
      ></app-moderat-sanierung-measure>
    }
  }
}
</fieldset>

<fieldset class="margin">
  <div class="grid-x grid-margin-x">
    <div class="cell small-6 medium-6">
      <legend [innerHTML]="'moderat.sanierung.massnahmen.technik.headline' | translate"></legend>
    </div>
    <div class="cell small-6 medium-5 text-right">
      <span class="unit" [innerHTML]="'moderat.sanierung.unit.kwh.saving' | translate"></span>
    </div>
  </div>

  @if(!measureData) {
    <div class="loading"></div>
  }
  @else {
  @for (measure of measures.additional; track measure) {
    @if (measureData[measure]) {
      <app-moderat-sanierung-measure
        (onToggleText)="onToggleText()"
        [measure]="measure"
        [maxSaving]="maxSaving"
        [form]="form"
        [formField]="measure"
        [internalPortal]="internalPortal"
        [saving]="measureData[measure].saving"
        [recommend]="measureData[measure].recommend"
        [recommendReason]="measureData[measure].recommendReason"
      ></app-moderat-sanierung-measure>
    }
  }
}
</fieldset>
</section>
